var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-11 col-sm-11 col-md-11 col-lg-12 margin-Top-5Perc width float-Right admin-Panel-Padding font-size-2vw admin-Panel-BG text-align-left padding-right-0Perc"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ac9b22d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ProfileHeaderBar.vue
// module id = null
// module chunks = 